import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import NotificationsSettingsPage, { getDefaultPageUI } from "components/pages/NotificationsSettingsPage";
import { getDefaultAddEmail } from "components/workflows/AddEmailContactMethodModalWorkflow";
import Classes from "model";

export default function CaptureNotifiLimEmailEntered(props) {
    const controller = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, controller);

    const modalData = BCMSStateManagerCRUD.init(getDefaultAddEmail("addEmailWorkflow", undefined))
        .update([ "data", "info", "value" ], "sample@samplemail.com")
        .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
        .update([ "modal", "id" ], "AddContactMethodModal")
        .update([ "modal", "data" ], { workflowType: "addEmailWorkflow", values: modalData })
        .submit();

    return <NotificationsSettingsPage ui={ ui } />
}